import React, {
	createContext,
	useContext,
	useEffect,
	useMemo,
	useState,
} from "react";
import { Role } from "../Enums/Roles";

interface IAuth {
	id: number;
	name: string;
	role: Role | undefined;
	avatar: string;
}

type IAuthContext = [IAuth, React.Dispatch<React.SetStateAction<IAuth>>];

const AuthContext = createContext<IAuthContext>([
	{
		id: 0,
		name: "",
		role: undefined,
		avatar: "",
	},
	() => null,
]);

function useAuth() {
	const context = useContext(AuthContext);
	if (context === undefined) {
		throw new Error("useAuth must be used within a AuthProvider");
	}
	return context;
}

function AuthProvider(props: any) {
	const [auth, setAuth] = useState<IAuth>({
		id: 0,
		name: "",
		role: undefined,
		avatar: "",
	});

	const value = useMemo(() => [auth, setAuth], [auth]);

	return <AuthContext.Provider value={value} {...props} />;
}

export { AuthProvider, useAuth };
